// @flow
import { PAGES_SHOPIFY_INTEGRATION } from 'src/constants/theme-settings';
import { TURBO_FEATURE } from './installation-v2';
import { getAssetURL } from 'src/helpers';
import { ADMIN_APP_ASSET_PATHS } from './assets';
export const LIMIT_CUSTOM_TEMPLATE_INSTANCE = 25;

export const TEMPLATE_FEATURE = {
  BOOST: 'boost',
  COLLECTION: 'collection',
  SEARCH: 'search',
  ISW: 'instant-search-widget',
  RECOMMENDATION: 'recommendation'
};

export const INTEGRATION_FEATURE = {
  COLLECTION: 'collectionFilters',
  SEARCH: 'searchPage',
  ISW: 'instantSearchWidget',
  RECOMMENDATION: 'recommendation'
};

export const WIDGET_FEATURES = [
  {
    pathId: TEMPLATE_FEATURE.COLLECTION,
    featureId: INTEGRATION_FEATURE.COLLECTION,
    name: 'Collection page with filters',
    content: 'AdminHTML.ShopifyIntegration.Onboarding.step03_Feature01_Content',
    img: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegration.collectionFeature)
  },
  {
    pathId: TEMPLATE_FEATURE.SEARCH,
    featureId: INTEGRATION_FEATURE.SEARCH,
    name: 'Search page with filters',
    content: 'AdminHTML.ShopifyIntegration.Onboarding.step03_Feature02_Content',
    img: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegration.searchWithFilterFeature)
  },
  {
    pathId: TEMPLATE_FEATURE.ISW,
    featureId: INTEGRATION_FEATURE.ISW,
    name: 'Instant search widget',
    content: 'AdminHTML.ShopifyIntegration.Onboarding.step03_Feature03_Content',
    img: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegration.iswFeature)
  }
  // {
  //   pathId: TEMPLATE_FEATURE.RECOMMENDATION,
  //   featureId: INTEGRATION_FEATURE.RECOMMENDATION,
  //   name: 'Recommendation widgets'
  // }
];

export const SSR_APP_BLOCK = {
  FILTER_PRODUCT_LIST_SSR: 'filter-product-list-ssr',
  RECOMMENDATION: 'recommendation-ssr',
  COUNTDOWN_TIMER: 'countdown-timer'
};

// For local storage
export const KEY_EDITOR_STATE = 'editor-state';

export const TEMPLATE_VALUE = {
  COLLECTION: 'collectionFilters',
  SEARCH: 'searchPage'
};
export const AVAILABLE_TEMPLATE = [TEMPLATE_VALUE.COLLECTION, TEMPLATE_VALUE.SEARCH];
export const MAPPING_AVAILABLE_TEMPLATE = {
  [PAGES_SHOPIFY_INTEGRATION.COLLECTION]: TEMPLATE_VALUE.COLLECTION,
  [PAGES_SHOPIFY_INTEGRATION.SEARCH]: TEMPLATE_VALUE.SEARCH
};

export const ERROR_CODE = {
  REACH_LIMIT: 'REACH_LIMIT',
  ALREADY_ADDED: 'ALREADY_ADDED'
};

const isStaging = process.env.REACT_APP_ENV === 'staging';

export const VISIBLE_TEMPLATE_SETTING_ELEMENT = {
  default: {
    PRODUCT_ITEM: isStaging ? '1.5.6' : '1.4.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.5.6' : '1.5.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.6.19' : '1.6.0',
    PRODUCT_ITEM_BTN_LAYOUT_3: isStaging ? '1.7.2' : '1.8.0',
    PRODUCT_ITEM_BTN_LAYOUT_BULK: isStaging ? '3.4.22' : '2.12.0',
    PRODUCT_ITEM_BTN_LAYOUT_4: isStaging ? '3.4.22' : '2.12.0',
    PRODUCT_ITEM_BTN_LAYOUT_6: isStaging ? '3.11.16' : '2.24.0',
    PRODUCT_ITEM_BTN_LAYOUT_7: isStaging ? '3.11.16' : '2.24.0',
    PRODUCT_ITEM_BTN_LAYOUT_5: isStaging ? '3.15.13' : '2.26.0',
    PRODUCT_ITEM_BTN_LAYOUT_8: isStaging ? '3.15.26' : '2.27.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '3.6.24' : '2.14.0',
    PRODUCT_VENDOR: isStaging ? '3.6.30' : '2.14.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '3.11.10' : '2.21.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '3.11.10' : '2.21.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '3.11.2' : '2.22.3',
    PRODUCT_SWATCH_BY: isStaging ? '6.0.7' : '2.34.0',
    SHOW_TEXT_ON_HOVERING: isStaging ? '3.11.2' : '2.22.3',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.5.6' : '2.44.0',
    CART_DRAWER: isStaging ? '6.0.103' : '2.45.0',
    SHOW_CURRENCY_CODES: isStaging ? '6.0.112' : '2.45.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '7.0.5' : '2.46.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '7.0.5' : '2.51.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '6.7.26' : '2.52.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '6.7.26' : '2.54.0'
  },
  dawn: {
    PRODUCT_ITEM: isStaging ? '1.5.3' : '1.4.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.5.3' : '1.5.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.6.14' : '1.6.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '3.6.24' : '2.14.0',
    PRODUCT_VENDOR: isStaging ? '3.6.30' : '2.14.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '3.11.10' : '2.21.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '3.11.10' : '2.21.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '3.11.2' : '2.22.3',
    PRODUCT_SWATCH_BY: isStaging ? '6.1.3' : '2.34.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.5.3' : '2.44.0',
    CART_DRAWER: isStaging ? '6.7.26' : '2.45.0',
    SHOW_CURRENCY_CODES: isStaging ? '6.7.38' : '2.45.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '6.7.46' : '2.46.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '6.7.46' : '2.51.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '6.7.26' : '2.52.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '6.7.26' : '2.54.0'
  },
  impulse: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.14.10' : '1.4.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.14.10' : '1.4.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.14.0' : '1.5.3',
    PRODUCT_SWATCH_BY: isStaging ? '1.3.3' : '1.17.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.27.0',
    CART_DRAWER: isStaging ? '1.6.39' : '1.28.0',
    SHOW_CURRENCY_CODES: isStaging ? '1.6.47' : '1.28.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '1.6.55' : '1.29.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '1.6.55' : '1.34.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '1.6.39' : '1.35.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '1.6.39' : '1.37.0'
  },
  warehouse: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.14.10' : '1.4.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.14.10' : '1.4.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.14.0' : '1.5.3',
    PRODUCT_SWATCH_BY: isStaging ? '6.1.3' : '1.57.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.67.0',
    CART_DRAWER: isStaging ? '6.7.0' : '1.68.0',
    SHOW_CURRENCY_CODES: isStaging ? '6.7.8' : '1.68.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '6.7.16' : '1.69.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '6.7.16' : '1.74.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '6.7.0' : '1.75.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '6.7.0' : '1.77.0'
  },
  symmetry: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.1.15' : '1.3.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.1.15' : '1.3.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.14.0' : '1.4.3',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.56.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.66.0',
    CART_DRAWER: isStaging ? '4.5.24' : '1.67.0',
    SHOW_CURRENCY_CODES: isStaging ? '4.5.32' : '1.67.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '4.5.40' : '1.68.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '4.5.40' : '1.73.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '4.5.24' : '1.74.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '4.5.24' : '1.76.0'
  },
  prestige: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.11.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.21.0',
    CART_DRAWER: isStaging ? '4.7.24' : '1.22.0',
    SHOW_CURRENCY_CODES: isStaging ? '4.7.32' : '1.22.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '4.7.40' : '1.23.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '4.7.40' : '1.28.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '4.7.24' : '1.29.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '4.7.24' : '1.31.0'
  },
  expanse: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.5.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '5.15.0',
    CART_DRAWER: isStaging ? '4.7.22' : '5.16.0',
    SHOW_CURRENCY_CODES: isStaging ? '4.7.31' : '5.16.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '4.7.38' : '5.17.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '4.7.38' : '5.22.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '4.7.22' : '5.23.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '4.7.22' : '5.25.0'
  },
  empire: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '5.5.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.15.0',
    CART_DRAWER: isStaging ? '4.7.22' : '1.16.0',
    SHOW_CURRENCY_CODES: isStaging ? '4.7.31' : '1.16.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '4.7.38' : '1.17.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '4.7.38' : '1.22.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '4.7.22' : '1.23.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '4.7.22' : '1.25.0'
  },
  focal: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.4.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.14.0',
    CART_DRAWER: isStaging ? '4.4.23' : '1.15.0',
    SHOW_CURRENCY_CODES: isStaging ? '4.4.30' : '1.15.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '4.4.38' : '1.16.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '4.4.38' : '1.21.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '4.4.23' : '1.22.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '4.4.23' : '1.24.0'
  },
  broadcast: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.3.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.13.0',
    CART_DRAWER: isStaging ? '4.7.22' : '1.14.0',
    SHOW_CURRENCY_CODES: isStaging ? '4.7.31' : '1.14.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '4.7.38' : '1.15.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '4.7.38' : '1.20.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '4.7.22' : '1.21.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '4.7.22' : '1.23.0'
  },
  motion: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '3.1.3' : '1.3.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.13.0',
    CART_DRAWER: isStaging ? '3.4.29' : '1.14.0',
    SHOW_CURRENCY_CODES: isStaging ? '3.4.36' : '1.14.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '3.4.44' : '1.15.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '3.4.44' : '1.20.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '3.4.29' : '1.21.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '3.4.29' : '1.23.0'
  },
  venue: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.3.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.13.0',
    CART_DRAWER: isStaging ? '4.6.20' : '1.14.0',
    SHOW_CURRENCY_CODES: isStaging ? '4.6.28' : '1.14.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '4.6.36' : '1.15.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '4.6.36' : '1.20.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '4.6.20' : '1.21.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '4.6.20' : '1.23.0'
  },
  testament: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '6.1.3' : '1.2.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.12.0',
    CART_DRAWER: isStaging ? '6.4.21' : '1.13.0',
    SHOW_CURRENCY_CODES: isStaging ? '6.4.28' : '1.13.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '6.4.36' : '1.14.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '6.4.36' : '1.19.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '6.4.21' : '1.20.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '6.4.21' : '1.22.0'
  },
  flow: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '4.1.3' : '1.1.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.10.0',
    CART_DRAWER: isStaging ? '4.7.22' : '1.12.0',
    SHOW_CURRENCY_CODES: isStaging ? '4.7.30' : '1.12.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '4.7.31' : '1.13.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '4.7.31' : '1.18.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '4.7.22' : '1.19.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '4.7.22' : '1.21.0'
  },
  blockshop: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '2.1.3' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.9.0',
    CART_DRAWER: isStaging ? '2.8.0' : '1.10.0',
    SHOW_CURRENCY_CODES: isStaging ? '2.8.9' : '1.10.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '2.8.17' : '1.11.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '2.8.17' : '1.16.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '2.8.0' : '1.17.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '2.8.0' : '1.19.0'
  },
  streamline: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '1.0.4' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.9.0',
    CART_DRAWER: isStaging ? '1.4.23' : '1.10.0',
    SHOW_CURRENCY_CODES: isStaging ? '1.4.30' : '1.10.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '1.4.38' : '1.11.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '1.4.38' : '1.16.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '1.4.23' : '1.17.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '1.4.23' : '1.19.0'
  },
  horizon: {
    PRODUCT_ITEM: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_RATING: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_SWATCH_QUICKVIEW_CART_PRICE_CTA: isStaging ? '1.0.0' : '1.0.0',
    CART_VISIBILITY_SETTINGS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_VENDOR: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_INVENTORY_STATUS: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_LIST_BREADCRUMBS: isStaging ? '1.0.0' : '1.0.0',
    COLLECTION_HEADER_PARALLAX: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_SWATCH_BY: isStaging ? '1.0.0' : '1.0.0',
    PRODUCT_ITEM_ADDITIONAL_WISHLIST: isStaging ? '1.0.0' : '1.0.0',
    CART_DRAWER: isStaging ? '1.0.32' : '1.1.0',
    SHOW_CURRENCY_CODES: isStaging ? '1.0.40' : '1.1.0',
    PRODUCT_TOOLBAR_SHOW_LIST_VIEW_DEFAULT: isStaging ? '1.0.50' : '1.2.0',
    PRODUCT_ITEM_VIDEO_GIF: isStaging ? '1.0.50' : '1.7.0',
    CART_DRAWER_COUNTDOWN_TIMER: isStaging ? '1.0.23' : '1.8.0',
    CARD_DRAWER_SIDE_LAYOUT: isStaging ? '1.0.23' : '1.10.0'
  }
};

export const SUPPORTED_TEMPLATE_VERSION_WITH_FILTER_TREE_AND_ISW_SETTINGS = isStaging
  ? '3.4.0'
  : '2.9.0';

export const MAP_LABEL_TURBO_INSTALLED_FEATURE = {
  [TURBO_FEATURE.COLLECTION_FILTER]: 'AdminHTML.ShopifyIntegration.Guide.menuCollectionPage',
  [TURBO_FEATURE.SEARCH_PAGE_FILTER]: 'AdminHTML.ShopifyIntegration.Guide.menuSearchPage',
  [TURBO_FEATURE.ISW]: 'AdminHTML.ShopifyIntegration.Guide.menuISW'
};

